import { render, staticRenderFns } from "./datatableListaPrestazioniAlpi.vue?vue&type=template&id=10818f56"
import script from "./datatableListaPrestazioniAlpi.vue?vue&type=script&lang=js"
export * from "./datatableListaPrestazioniAlpi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports